export const HISTORY_MODE = 'HISTORY_MODE';
export const LAST_LOCATION_MODE = 'LAST_LOCATION_MODE';
